import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { baseURL } from '../include/api';
import Slider from 'react-slick';

const FeatureOne = ({ categoryList }) => {
  const scrollRef = useRef(null);

   function SampleNextArrow(props) {
     const { className, onClick } = props;
     return (
       <button
         type="button"
         onClick={onClick}
         className={` ${className} slick-next slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1`}
       >
         <i className="ph ph-caret-right" />
       </button>
     );
   }
   function SamplePrevArrow(props) {
     const { className, onClick } = props;

     return (
       <button
         type="button"
         onClick={onClick}
         className={`${className} slick-prev slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1`}
       >
         <i className="ph ph-caret-left" />
       </button>
     );
   }
   const settings = {
     dots: false,
     arrows: true,
     infinite: true,
     speed: 1000,
     slidesToShow: 10,
     slidesToScroll: 1,
     initialSlide: 0,
     nextArrow: <SampleNextArrow />,
     prevArrow: <SamplePrevArrow />,
     responsive: [
       {
         breakpoint: 1699,
         settings: {
           slidesToShow: 9,
         },
       },
       {
         breakpoint: 1599,
         settings: {
           slidesToShow: 8,
         },
       },
       {
         breakpoint: 1399,
         settings: {
           slidesToShow: 6,
         },
       },
       {
         breakpoint: 992,
         settings: {
           slidesToShow: 5,
         },
       },
       {
         breakpoint: 768,
         settings: {
           slidesToShow: 4,
         },
       },
       {
         breakpoint: 575,
         settings: {
           slidesToShow: 3,
         },
       },
       {
         breakpoint: 424,
         settings: {
           slidesToShow: 2,
         },
       },
       {
         breakpoint: 359,
         settings: {
           slidesToShow: 1,
         },
       },
     ],
  };
  const colors = [
  "#E8F9E9",
  "#FCEDED",
  "#F6EBF3",
  "#FCF2E7",
  "#F5FBE3",
  "#E3FBE9",
  "#E9E3FB",
  "#ECF8F2",
  "#F8F5E5",
  "#F0F8E5"
];


  return (
    <div className="feature" id="featureSection">
      <div className="container container-lg ">
        <div className="position-relative arrow-center">
          <div className="flex-align">
            <button
              type="button"
              id="feature-item-wrapper-prev"
              className="slick-prev slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1"
            >
              <i className="ph ph-caret-left" />
            </button>
            <button
              type="button"
              id="feature-item-wrapper-next"
              className="slick-next slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1"
            >
              <i className="ph ph-caret-right" />
            </button>
          </div>
          <div className="feature-item-wrapper">
            <Slider {...settings}>
              {categoryList?.slice(0, 100).map((item, index) => (
                <div className="feature-item text-center" key={index}>
                  <div
                    className="feature-item__thumb rounded-circle"
                    style={{
                      backgroundColor: colors[index % colors.length],
                    }}
                  >
                    <Link
                      to={`/category-products/${item.id}`}
                      className="w-100 h-100 d-flex align-items-center justify-content-center"
                    >
                      <img
                        src={`${baseURL}/${item.imageUrl}`}
                        alt={item.name}
                        style={{
                          maxWidth: "70%",
                          maxHeight: "70%",
                          objectFit: "cover",
                        }}
                      />
                    </Link>
                  </div>
                  <div className="feature-item__content mt-3">
                    <h6 className="text-md mb-1">
                      <Link
                        to={`/category-products/${item.id}`}
                        className="text-inherit"
                      >
                        {item.name}
                      </Link>
                    </h6>
                    {/* <span className="text-sm text-gray-400">125+ Products</span> */}
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureOne;


